module.exports = __webpack_public_path__ + "static/img/m_faq_questions_icon@3x.8c1d977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_faq_questions_icon@3x.png
// module id = wOam
// module chunks = 1